import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

import { createVuetify } from "vuetify";
import { createVueI18nAdapter } from "vuetify/locale/adapters/vue-i18n";
import { useI18n } from "vue-i18n";
import { i18n } from "@/i18n";


const adapter = createVueI18nAdapter({ i18n, useI18n });

export default createVuetify({
    locale: {
        adapter
    },
    theme: {
        defaultTheme: "system",
        themes: {
            light: {
                colors: {
                    primary: "#071E4A",
                    secondary: "#D7E7F2",
                    error: "#FF8D87",
                    warning: "#FFE88C",
                    success: "#1C8698",
                    grafanaBackground: "#FBFBFB"
                },
            },
            dark: {
                colors: {
                    primary: "#AAB2CA",
                    secondary: "#41494F",
                    error: "#FF8D87",
                    warning: "#FFE88C",
                    success: "#1C8698",
                    grafanaBackground: "#111217"
                },
            },
        }
    },
});





